(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('kanbanBoard', kanbanBoard);

	kanbanBoard.$inject = ['$scope', '$rootScope', '$state', '$location', '$timeout', '$uibModal', '$q', '$window',
		'viewProjectsService', 'orderByFilter', 'leanFilterService', 'editProjectService',
		'a3ModalService', 'leanProjectsService', 'pageTimingService', 'redirectParamsService', 'storeService', 'tableService', '$experiments'];
	function kanbanBoard($scope, $rootScope, $state, $location, $timeout, $uibModal, $q, $window,
			viewProjectsService, orderByFilter, leanFilterService, editProjectService,
			a3ModalService, leanProjectsService, pageTimingService, redirectParamsService, storeService, tableService, $experiments) {
		var vm = this;
		var unsubscribe;
		var reportSettingsName = 'projects-kanban';
		vm.reportName = 'Kanban board (lean projects)';
		var extraParams = [{}];
		var masterStageList;
		var stageListMap = {};
		var organizeToken = 0;

		vm.stageList = [];
		vm.pageTitle = 'Lean Projects';
		vm.openA3 = openA3;
		vm.badDate = badDate;
		vm.openNewProject = openNewProject;
		vm.openViewProjectsGrid = openViewProjectsGrid;
		vm.moveProjectToStage = moveProjectToStage;

		// Buttons
		vm.showGridView = true;
		vm.showAddProject = true;

		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		if (!reportSettingsId) {
			$timeout(function() {
				jQuery('li.list-group-item.selected').removeClass('selected');
				jQuery('#viewKanban').addClass('selected');
			}, 0);
		}

		$scope.filterService = leanFilterService;

		var defaultFilters = [
			{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true},
			{ 'id': 'projectArea', 'values': [leanFilterService.leanDnaAllSelected] },
			{ 'id': 'projectSavings', 'values': ['Target Annual Savings'] },
			{ 'id': 'timePeriod', 'value': 'all' }
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			showExcel: false,
			hideSearch: true
		};

		vm.getData = getData;
		vm.getMeta = getMeta;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = vm.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			organizeToken++;
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function getMeta() {
			return meta;
		}

		function getData() {
			var factoryListStr = leanFilterService.getFactoryList();
			tableService.trackPageView(reportSettingsName, factoryListStr);

			var factoryList = [];
			if (!factoryListStr || !factoryListStr.length){
				factoryList = [globalConfig.factory.id];
			} else {
				factoryList = factoryListStr.split(',');
			}
			var resolveMap = {};
			for (var i = 0; i < factoryList.length; i++) {
				resolveMap[factoryList[i]] = leanProjectsService.getStages(factoryList[i]);
			}
			if (factoryList && factoryList.length > 1) {
				vm.showSite = true;
			} else {
				vm.showSite = false;
			}
			resolveMap.stages = viewProjectsService.getStageList(factoryList, true);
			$q.all(resolveMap).then(function(resolutions) {
				masterStageList = resolutions.stages;
				var savingsType = $scope.filterService.getSelectedIds('projectSavings');
				for (var key in resolutions) {
					if (key !== 'stages') {
						stageListMap[key] = resolutions[key];
					}
				}
				// Default savings type when no filter value is selected
				if (!savingsType || !savingsType.length) {
					savingsType = ['Actual Total Savings'];
				}
				vm.savingsType = savingsType[0];
				vm.showChecks = _.startsWith(savingsType[0], 'Actual');
				vm.conversionFactorBySite = null;
				$timeout(function () {
					if (reportSettingsName === globalReportName || reportSettingsId === globalReportName) {
						viewProjectsService.getData(true).then(function (data) {
							var list = [];
							if (data && data.data) {
								list = data.data;
							}

							vm.conversionFactorBySite = data.conversionFactorBySite ? data.conversionFactorBySite : null;
							vm.targetCurrency = data.targetCurrency ? data.targetCurrency : globalConfig.browser.currencySymbol;
							if (checkForExtraStages()) {
								organizeProjects(list);
							}
							$timeout(function () {
								pageTimingService.submitUserTiming('Kanban Board');
							});
						});
					}
				}, 0);
			});
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.useFactoryFilter = true;
			leanFilterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			var timePeriodFilter = leanFilterService.filterDefinitions['TimePeriod'];
			timePeriodFilter.removable = false;
			siteFilter.removable = false;
			siteFilter.type = 'multiselect';
			$scope.filterService.setMasterFilterList([
				$scope.filterService.filterDefinitions.BusinessUnit,
				siteFilter,
				$scope.filterService.filterDefinitions.ProjectArea,
				$scope.filterService.filterDefinitions.ProjectStage,
				$scope.filterService.filterDefinitions.ProjectCategories,
				$scope.filterService.filterDefinitions.ProjectTypes,
				$scope.filterService.filterDefinitions.ProjectGoals,
				$scope.filterService.filterDefinitions.ProjectManager,
				$scope.filterService.filterDefinitions.ProjectSavingsCategories
			]);
			$scope.filterService.setMasterSingleSelectFilterList([
				$scope.filterService.filterDefinitions.ProjectSavings
			]);

			$scope.filterService.setMasterRangeFilterList([
				timePeriodFilter
			]);
			leanFilterService.addCustomFieldsFilters();
		}

		var ORGANIZE_CHUNK_SIZE = 1000;

		function ensureStageBucket(stg) {
			if (!vm.projectsMap[stg]) {
				vm.projectsMap[stg] = {};
				vm.projectsMap[stg].totalSavings = 0;
				vm.projectsMap[stg].projects = [];
			}
		}

		function organizeProjects(pList) {
			var myToken = ++organizeToken;
			for (var i = 0; i < vm.stageList.length; i++) {
				ensureStageBucket(vm.stageList[i].stageSequence);
			}

			var index = 0;
			function processChunk() {
				if (myToken !== organizeToken) {
					return;
				}
				var end = Math.min(index + ORGANIZE_CHUNK_SIZE, pList.length);
				for (; index < end; index++) {
					var proj = pList[index];
					var stg = proj.stageSequence;
					ensureStageBucket(stg);
					var conversionFactory = 1;
					var ldf = proj.leanDirFactoryNdx;
					if (vm.conversionFactorBySite && vm.conversionFactorBySite[ldf]) {
						conversionFactory = vm.conversionFactorBySite[ldf];
					}
					proj.savings = proj.savings * conversionFactory;
					vm.projectsMap[stg].totalSavings += proj.savings;
					proj.name = strip(proj.name);
					proj.isBadDate = badDate(proj);
					vm.projectsMap[stg].projects.push(proj);
				}
				if (index < pList.length) {
					$timeout(processChunk, 0);
				}
			}

			processChunk();
		}

		function updateTotal(stage) {
			vm.projectsMap[stage].totalSavings = 0;
			angular.forEach(vm.projectsMap[stage].projects, function(proj) {
				vm.projectsMap[stage].totalSavings += proj.savings;
			});
		}

		function checkForExtraStages() {
			var filterObjList;
			var stageFilter = $scope.filterService.getFilterById('stageId');
			var stageList = [];
			if (stageFilter && stageFilter['objectList']) {
				filterObjList = stageFilter.objectList;
				var pendAppIndex = -1;
				var archIndex = -1;
				for (var i = 0; i < filterObjList.length; i++) {
					if (filterObjList[i].name == 'Pending Approval') {
						pendAppIndex = i;
					} else if (filterObjList[i].name == 'Archive') {
						archIndex = i;
					}
				}

				if (pendAppIndex > -1 && filterObjList[pendAppIndex].selected) {
					stageList.push({ id: filterObjList[pendAppIndex].id, name: 'Pending Approval', stageSequence: '-1' });
				}
				angular.forEach(masterStageList, function(stg) {
					stageList.push(stg);
				});
				if (archIndex > -1 && filterObjList[archIndex].selected) {
					stageList.push({ id: filterObjList[archIndex].id, name: 'Archive', stageSequence: '1000' });
				}
			}

			vm.stageList = stageList;
			vm.projectsMap = {};
			angular.forEach(vm.stageList, function(stg) {
				vm.projectsMap[stg.id] = {};
				vm.projectsMap[stg.id].totalSavings = 0;
				vm.projectsMap[stg.id].projects = [];
			});
			return stageList.length > 0;
		}

		function moveProjectToStage(project, newStageSeq) {
			if (!project) {
				return;
			}
			var oldStageSeq = project.stageSequence;
			if (String(oldStageSeq) === String(newStageSeq)) {
				return;
			}

			var projObj = { id: project.projNdx, stageSequence: newStageSeq };
			var tempStgList = stageListMap[project.leanDirFactoryNdx] || [];
			var newStage;
			var validStage = false;
			for (var i = 0; i < tempStgList.length; i++) {
				if (tempStgList[i].stageSequence == newStageSeq) {
					projObj.stageId = tempStgList[i].id;
					newStage = projObj.stageId;
					validStage = true;
				}
			}
			if (!authorizeTransition(oldStageSeq, project, newStageSeq) || !validStage) {
				var toastMessage;
				if (!validStage) {
					toastMessage = 'The stage you are trying to move this project doesn\'t exist for that project\'s site';
				} else if (oldStageSeq == -1) {
					toastMessage = 'You are not authorized to approve this project. <br/>Please contact a system administrator to move this project to another stage';
				} else {
					toastMessage = 'You are not authorized to move this project to a different stage. Please contact the project manager <br/> or system administrator to move the project to another stage';
				}
				$rootScope.$emit('toast', {'message': toastMessage, 'success': false, 'time': 6000});
				return;
			}

			var sourceProjects = vm.projectsMap[oldStageSeq].projects;
			var sourceIndex = sourceProjects.indexOf(project);
			if (sourceIndex > -1) {
				sourceProjects.splice(sourceIndex, 1);
			}
			vm.projectsMap[newStageSeq].projects.push(project);
			updateTotal(oldStageSeq);
			updateTotal(newStageSeq);

			viewProjectsService.saveProject(projObj, project.leanDirFactoryNdx, (new Date(project.lastModified)).toUTCString())
				.then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						project.stageId = newStage;
						project.stageSequence = newStageSeq;
						project.isBadDate = badDate(project);
						updateLastModified(project);
						vm.projectsMap[newStageSeq].projects = orderByFilter(vm.projectsMap[newStageSeq].projects, 'savings', true);
						addTransitionClass(newStageSeq, 'success', project.projNdx);
					} else if (response && response.status == 412) {
						revertMove(project, oldStageSeq, newStageSeq);
						$rootScope.$emit('toast', {'message': 'This project has been updated since you loaded the page, please refresh the page', 'success': false});
						addTransitionClass(oldStageSeq, 'failure');
					} else {
						revertMove(project, oldStageSeq, newStageSeq);
						$rootScope.$emit('toast', {'message': 'Unexpected server errror', 'success': false});
						addTransitionClass(oldStageSeq, 'failure');
					}
				});
		}

		function revertMove(project, oldStageSeq, newStageSeq) {
			var destProjects = vm.projectsMap[newStageSeq].projects;
			var destIndex = destProjects.indexOf(project);
			if (destIndex > -1) {
				destProjects.splice(destIndex, 1);
			}
			vm.projectsMap[oldStageSeq].projects.push(project);
			vm.projectsMap[oldStageSeq].projects = orderByFilter(vm.projectsMap[oldStageSeq].projects, 'savings', true);
			updateTotal(oldStageSeq);
			updateTotal(newStageSeq);
		}

		function authorizeTransition(oldStageSeq, project, newStageSeq) {
			if (globalConfig.user.authFacts[project.leanDirFactoryNdx].profileType === 'SystemAdministrator'
				 || globalConfig.user.authFacts[project.leanDirFactoryNdx].profileType === 'SuperSystemAdministrator'
					 || globalConfig.user.authFacts[project.leanDirFactoryNdx].initAuthz ||
					 project.userIsApprover) {
				return true;
			} else {
				if (globalConfig.user.id == project.creatorNdx && oldStageSeq == -1 && newStageSeq == 1000) {
					return true;
				}
				var adminNdxList = [];
				if (project.adminNdx && project.adminNdx.length) {
					adminNdxList = project.adminNdx.split(',');
				}
				var projectSponsorNdxList = [];
				if (project.projectSponsorNdxs && project.projectSponsorNdxs.length) {
					projectSponsorNdxList = project.projectSponsorNdxs.split(',');
				}
				if (globalConfig.user.id != project.projectManagerNdx && adminNdxList.indexOf('' + globalConfig.user.id) < 0 &&
					projectSponsorNdxList.indexOf('' + globalConfig.user.id) < 0) {
					return false;
				} else {
					var oldStageName = '';
					angular.forEach(stageListMap[project.leanDirFactoryNdx], function(stage) {
						if (stage.stageSequence == oldStageSeq) {
							oldStageName = stage.name;
						}
					});
					return oldStageName != 'Pending Approval';
				}
			}
		}

		function addTransitionClass(stage, status, projIndex) {
			var index = -1;
			for (var i = 0; i < vm.projectsMap[stage].projects.length; i++) {
				if (vm.projectsMap[stage].projects[i].projNdx == projIndex) {
					index = i;
					break;
				}
			}
			vm.projectsMap[stage].backgroundClass = 'move-' + status;
			if (index != -1) {
				vm.projectsMap[stage].projects[index].borderClass = 'move-' + status;
			}
			$timeout(function() {
				vm.projectsMap[stage].backgroundClass = 'done-move';
				if (index != -1) {
					vm.projectsMap[stage].projects[index].borderClass = 'done-move';
				}
			}, 500);
		}

		function openA3(projNdx, factoryId) {
			if (!factoryId) factoryId = globalConfig.factory.id;
			var modalInstance = a3ModalService.openModal(projNdx, factoryId);

			modalInstance.result.finally(function() {
				a3ModalService.removeNoPrintClass();
			});
		}

		function badDate(project) {
			if (project.completeFlag) {
				return false;
			}
			if (project.stageName == 'Archive') {
				return false;
			}
			var projStage = project.stageId;
			var stageIndex = -1;
			for (var i = 0; i < masterStageList.length; i++) {
				if (masterStageList[i].id == projStage) {
					stageIndex = i;
				}
			}
			if (stageIndex == masterStageList.length - 1) {
				return false;
			}
			return moment().isAfter(project.dueDate, 'day');
		}

		function openNewProject() {
			var newProjectScope = $scope.$new();
			newProjectScope.isSupplierProject = false;
			newProjectScope.filterService = $scope.filterService;

			var opts = {
				scope: newProjectScope,
				templateUrl: '/application/f/lean-projects/new-project/new-project.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			newProjectScope.closeDialog = function() {
				instance.close();
				newProjectScope.$destroy();
			};

			newProjectScope.result = function(message, isSuccessful, stageId) {
				instance.close();
				newProjectScope.$destroy();
				var time = 3000;
				if (isSuccessful) {
					addStageIdToFilter(stageId);
				}
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful, 'time': time});
				if (isSuccessful) getData();
			};

			newProjectScope.addToastMessage = function(message, type) {
				$rootScope.$emit('toast', {'message': message, 'success': type});
			};
		}

		function addStageIdToFilter(stageId) {
			var stageFilter = $scope.filterService.getFilterById('stageId');
			var isPending = false;
			var indexInFilter = -1;
			for (var i = 0; i < stageFilter.objectList.length; i++) {
				if (stageFilter.objectList[i].id == stageId) {
					if (!stageFilter.objectList[i].selected) {
						stageFilter.objectList[i].selected = true;
						$scope.filterService.updateActiveFilters();
					}
					break;
				}
			}
		}

		function updateLastModified(project) {
			editProjectService.getLastModified(project.projNdx, project.leanDirFactoryNdx)
				.then(function(data) {
					if (data && data[0]) {
						project.lastModified = data[0].lastModified;
					}
				});
		}

		function getTimePeriodFilterQueryParam(filterKey, rawValue) {
			var timePeriodQueryParam = filterKey + '=';
			var decodedValue = decodeURIComponent(rawValue);
			if (_.startsWith(decodedValue, '{') && _.endsWith(decodedValue, '}')) {
				timePeriodQueryParam += 'custom';
				decodedValue = JSON.parse(decodedValue);
				if (decodedValue.startDate && decodedValue.endDate) {
					timePeriodQueryParam += '&' + filterKey + 'ValueOne=' + decodedValue.startDate;
					timePeriodQueryParam += '&' + filterKey + 'ValueTwo=' + decodedValue.endDate;
					timePeriodQueryParam += '&' + filterKey + 'ValueComparator=btw';
				}
			} else {
				timePeriodQueryParam += rawValue;
			}
			return timePeriodQueryParam;
		}

		function openViewProjectsGrid() {
			var url = '/application/f/home.html#/lean-projects/view-projects/?drilldown=1';
			var qParams = leanFilterService.getQueryParam();
			for (var i = 0; i < qParams.length; i++) {
				if (qParams[i]['key'] === 'timePeriod') {
					url += '&' + getTimePeriodFilterQueryParam(qParams[i]['key'], qParams[i]['value']);
				} else {
					url += '&' + qParams[i]['key'] + '=' + qParams[i]['value'];
				}
			}

			//Get selected factories
			var factoriesStr = leanFilterService.getFactoryList();
			var factoryList = factoriesStr && factoriesStr.length ? factoriesStr.split(',') : [globalConfig.factory.id];
			var stageString = '';
			//Get stage Ids that are not pending approval or archived
			for (var i = 0; i < factoryList.length; i++) {
				var stageList = stageListMap[factoryList[i]];
				if (stageList && stageList.length) {
					for (var j = 0; j < stageList.length; j++) {
						if (stageList[j].stageSequence !== -1 && stageList[j].stageSequence !== 1000) {
							stageString += stageList[j].id + ',';
						}
					}
				}
			}

			var filterObjList = $scope.filterService.getFilterById('stageId').objectList;
			for (var i = 0; i < filterObjList.length; i++) {
				if ((filterObjList[i].name == 'Pending Approval' || filterObjList[i].name === 'Archive')
						&& filterObjList[i].selected) {
					stageString += filterObjList[i].id + ',';
				}
			}
			if (stageString && stageString.length) {
				stageString = stageString.substring(0, stageString.length - 1);
				url += '&projectStageId=' + stageString;
			}
			if (factoriesStr && factoriesStr.length) {
				url += '&factory=' + factoriesStr;
			}
			$window.location.href = url;
		}

		init();
	}
})();
